/**
 * Layout options for the whole app.
 *
 * `ssr = false` is the important one. This interface is client-side by nature: the
 * renderer is BlueMap's own web app inside a frame, all configuration is public, and
 * there is nothing to render on a server that the browser cannot do better. Turning
 * SSR off also removes an entire class of hydration and `window`-access bugs from
 * components that legitimately need the DOM.
 *
 * With `prerender = false` and `adapter-static`'s `fallback: 'index.html'`, every
 * route, including `/<slug>/` for any slug, is served the same single-page shell,
 * which is what makes map selection URL-addressable without a build entry per map.
 *
 * `trailingSlash = 'always'` is what makes `/nether/` the canonical form. Navigation
 * through `resolve()` and `goto()` is normalised to it by the router, so a slashless
 * path lands on the slashed one without a round trip. The single exception is the root
 * redirect in `+page.ts`, which builds its URL by hand and spells the slash out.
 */
export const ssr = false;
export const prerender = false;
export const trailingSlash = 'always';
